export default __webpack_public_path__ + "static/media/001-shorts.f4ab889d.svg";